'use client';
import React from 'react';

export default function ParallaxSection({
  imageUrl,
  height = 'h-80',
  overlayColor = 'bg-secondary/75',
  className = '',
  children,
}) {
  return (
    <section
      className={`tablet:p-8 relative bg-cover bg-fixed bg-center p-4 ${className} ${height}`}
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <div className={`absolute inset-0 ${overlayColor}`}></div>

      <div className="relative z-10 flex h-full items-center justify-center">
        <div className="tablet:grid-cols-2 tablet:grid-rows-1 relative mx-auto grid grid-cols-1 items-center gap-6 px-6 text-center">
          {children}
        </div>
      </div>
    </section>
  );
}
